export default __webpack_public_path__ + "static/media/calender.6cc48254.svg";